export enum CustomerFeedbackProblemType {
  MyProvider = 'my-provider',
  UsingApp = 'using-app'
}

export enum FeedbackStatuses {
  Hidden = 'hidden',
  New = 'new',
  Published = 'published'
}
